import { Flex } from "@hopper-ui/components";
import { ConversationHistoryCategory } from "@/features/conversations/components/conversation-history/ConversationHistoryCategory.tsx";
import { ConversationHistoryEmptyState } from "@/features/conversations/components/conversation-history/ConversationHistoryEmptyState.tsx";
import { useCategorizedConversations, useGetConversationsSuspenseQuery, useSharedTranslation } from "@workleap-ai/shared";

export const ConversationHistory = () => {
    const { tShared } = useSharedTranslation();
    const { data: conversations } = useGetConversationsSuspenseQuery();

    const { thisWeekConversations, lastWeekConversations, olderConversations } = useCategorizedConversations(conversations);

    return (
        <Flex
            overflowY="auto"
            paddingX="inset-sm"
            direction="column"
            gap="inline-xl"
            position="relative"
            grow={1}
            className="wai-conversation-history"
        >
            {conversations.length === 0 ? <ConversationHistoryEmptyState /> :
                <>
                    <ConversationHistoryCategory
                        title={tShared("thisWeek")}
                        conversations={thisWeekConversations}
                    />
                    <ConversationHistoryCategory
                        title={tShared("lastWeek")}
                        conversations={lastWeekConversations}
                    />
                    <ConversationHistoryCategory
                        title={tShared("older")}
                        conversations={olderConversations}
                    />
                </>
            }
        </Flex>
    );
};
